export default __webpack_public_path__ + "static/media/bodyImage.139257bd.JPG";